import React, { useState, useEffect } from "react";
import AWS from 'aws-sdk';
import { getCategoriesList, getUrlCategory, submitRecatRequest, getRecatRequestStatus } from "../services/user.service";
import { ReloadOutlined, CloseCircleFilled, CheckCircleFilled, ClockCircleOutlined, QuestionCircleOutlined, InfoCircleFilled } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import {
  Spin,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  Table,
  message,
  Typography,
  Alert,
  Result,
  Tooltip
} from 'antd';
import AWSConfig from '../aws-config';
import {
  S3Client, ListBucketsCommand, ListObjectsCommand,
  ListObjectsCommandOutput, GetObjectCommand, DeleteObjectCommand, PutObjectCommand
} from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { CognitoIdentityClient, GetIdCommand } from "@aws-sdk/client-cognito-identity";
import { Config, CognitoIdentityCredentials, CognitoIdentityServiceProvider } from "aws-sdk";
import "./Home.css";

import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
  CognitoUserSession,
  CognitoIdToken,
  CognitoAccessToken
} from 'amazon-cognito-identity-js';
import { responsivePropType } from "react-bootstrap/esm/createUtilityClasses";
import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";
const { Text, Link } = Typography;

const { TextArea } = Input;
interface rowDataType {
  key: number,
  request_id: number,
  url: string,
  existing_category_id: number
  request_category_id: number
  status: string,
  description: string,
  created_at: string
  last_updated: string

}
const CSV_HEADER = ["request_id", "url", "existing_category_id", "request_category_id", "status", "description", "created_at", "last_updated", "updated_category_id"];
const s3client = new S3Client({
  region: "us-east-1",
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: "us-east-1" },
    identityPoolId: "us-east-1:8f844ccb-ce6e-48d4-a65e-0ffb145b39bb",
    logins: {
      "cognito-idp.us-east-1.amazonaws.com/us-east-1_JUoovTVPK": localStorage.getItem('id_token') || ''
    }
  }),
});
const Home: React.FC = () => {
  const [content, setContent] = useState<string>("");
  const [categoriesList, setCategoriesList] = useState([]);
  const [categoriesIndex, setCategoriesIndex] = useState({});
  const [newCategory, setNewCategory] = useState({ category_id: 0, category_name: '' });

  const [currentCategory, setCurrentCategory] = useState({ category_id: 0, category_name: '--', loading: false });

  const [resultStatus, setResultStatus] = useState({ success: false, error: false, message: '' });
  const [requestStatusLoading, setRequestStatusLoading] = useState({});

  const [spinner, setSpinner] = useState(false);
  const [catSpinner, setCatSpinner] = useState(false);
  const [reqSpinner, setReqSpinner] = useState(false);
  const [cognitoIdentityID, setCognitoIdentityID] = useState("");
  const [csvString, setCsvString] = useState("");
  const [recatRequestsData, setRecatRequestsData] = useState([]);
  const [rowIndex, setRowIndex] = useState(0);
  const [isFormError, setIsFormError] = useState(false);
  // const formRef = Form.useFormInstance();
  const [form] = Form.useForm();
  const handleSave = (values: any) => {
    setReqSpinner(true);
    const recatReqPayload = {
      url: values.url,
      request_category_id: values.request_category_id,
      request_category_name: categoriesIndex[values.request_category_id].category_name
    }
    if (recatReqPayload.request_category_name === currentCategory.category_name) {
      setIsFormError(true);
      setReqSpinner(false);
      return false;
    }
    setIsFormError(false);
    /*     setTimeout(() => {
          setSpinner(false);
          setResultStatus({...resultStatus, success: true, error: false, message: 'Request ID#: 1234567 is created successfully at 7th November, 2023 15:22:00 IST'});
        }, 5000) */

     submitRecatRequest(recatReqPayload).then(response => {
      if (response.data.status === 'accepted') {
        if (response.data.urlrequests[0].status == 'accepted') {
          const rowObj = {
            "key": rowIndex + 1,
            "request_id": response.data.urlrequests[0].id,
            "url": values.url,
            "existing_category_id": currentCategory.category_id,
            "request_category_id": values.request_category_id,
            "status": response.data.urlrequests[0].status,
            "description": values.description,
            "created_at": response.data.urlrequests[0].accepted_at,
            "last_updated": "-"
          }
          console.log(rowObj);
          const data = [...recatRequestsData];
          data.unshift(rowObj);
          setRecatRequestsData(data);
          uploadData(data);
          form.resetFields();
          setReqSpinner(false);
          setResultStatus({ ...resultStatus, success: true, error: false, message: 'Request ID#: ' + response.data.urlrequests[0].id + ' is created successfully at ' + moment.utc(response.data.urlrequests[0].accepted_at).local().format('MMM DD, YYYY HH:mm A') });
        }
        else {
          setResultStatus({ ...resultStatus, success: false, error: true, message: ' Failed to create request. ' + response.data.urlrequests[0].status });
          setReqSpinner(false);
        }
      }
      else {
        setResultStatus({ ...resultStatus, success: false, error: true, message: ' Failed to create request. ' + response.data.urlrequests[0].status });
        setReqSpinner(false);
      }
    })
      .catch(err => {
        setResultStatus({ ...resultStatus, success: false, error: true, message: 'Failed to Submit Request. Please Try Again !!' });
        setReqSpinner(false);
      });
  };
  const getUserInformation = () => {
    const creds = fromCognitoIdentityPool({
      clientConfig: { region: 'us-east-1' }, // Configure the underlying CognitoIdentityClient.
      identityPoolId: 'us-east-1:8f844ccb-ce6e-48d4-a65e-0ffb145b39bb',
      logins: { // LoginsMap
        "cognito-idp.us-east-1.amazonaws.com/us-east-1_JUoovTVPK": localStorage.getItem('id_token') || '',
      },
    });
    const res = creds().then(data => {
      console.log(data);
    });

    const client = new S3Client({
      region: 'us-east-2',
      credentials: creds,
    });
    const cognitoidentityserviceprovider = new CognitoIdentityServiceProvider({region: 'us-east-1'});
    const accessTkn = localStorage.getItem('access_token');
     cognitoidentityserviceprovider.getUser({AccessToken: accessTkn}).promise().then((data) => {
          console.log(data);
    });
    console.log(client);
  }
  const getIdentityId = async () => {
    if (localStorage.getItem('CognitoIdentityID')) {
      return localStorage.getItem('CognitoIdentityID');
    }
    const idclient = new CognitoIdentityClient(
      {
        region: "us-east-1",
      }
    );
    const input = { // GetIdInput
      region: "us-east-1",
      // AccountId: "us-east-1_JUoovTVPK",
      IdentityPoolId: AWSConfig.IDENTITY_POOL_ID, // required
      Logins: { // LoginsMap
        "cognito-idp.us-east-1.amazonaws.com/us-east-1_JUoovTVPK": localStorage.getItem('id_token') || '',
      },
    };
    const GetIdCommandcommand = new GetIdCommand(input);
    return idclient.send(GetIdCommandcommand).then(response => {
      setCognitoIdentityID(response.IdentityId);
      localStorage.setItem("CognitoIdentityID", response.IdentityId)
      return Promise.resolve(response.IdentityId);
    })
      .catch(error => {
        return Promise.reject("Unable to fetch IdentityId");
      })
  }
  const uploadData = async (data: any) => {
    // localStorage.setItem('recatData',JSON.stringify(data));
    //First Delete the CSV file.
    const deleted = await deleteFile();

    const csvArray = [CSV_HEADER.join()];
    data.forEach(rowObject => {
      const rowArray = CSV_HEADER.map(key => {
        return rowObject[key]
      });
      csvArray.push(rowArray.join(","));
    });
    const csvString = csvArray.join("\r\n");
    const params = { // PutObjectRequest
      Bucket: AWSConfig.BUCKET, // required
      Key: localStorage.getItem('CognitoIdentityID') + "/url-recat-req.csv", // required
      Body: csvString
    }
    const command = new PutObjectCommand(params);

    s3client.send(command).then((response) => {
      // alert("Uploaded successfully");
      // setRefreshkey(oldkey => oldkey + 1);
    })
      .catch(error => {
        message.error("Error on Upload");
      })
  };
  const processPromisesBatch = async (
    items: Array<any>,
    limit: number,
    fn: (item: any) => Promise<any>,
  ): Promise<any> => {
    let results = [];
    for (let start = 0; start < items.length; start += limit) {
      const end = start + limit > items.length ? items.length : start + limit;
      const slicedResults = await Promise.allSettled(items.slice(start, end).map(fn));
      results = [
        ...results,
        ...slicedResults,
      ]
    }
    return results;
  }
  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  const readFile = async () => {
    const params = { // GetObjectRequest
      Bucket: AWSConfig.BUCKET, // required
      Key: localStorage.getItem('CognitoIdentityID') + "/url-recat-req.csv", // required
      ResponseCacheControl: "no-cache"
    }
    // const command = new ListObjectsCommand({ Bucket: "urlrecategorization" });
    const command = new GetObjectCommand(params);
    return s3client.send(command).then((response) => {
      response.Body?.transformToString().then(str => {
        const csvArray = str.split("\r\n");
        const header = csvArray.shift()?.split(",");
        const parsedRows = [];
        const requests = csvArray.map((row, index) => {
          if (row.length > 0) {
            let obj = {
              key: index
            };
            row.split(",").forEach((element, index) => {
              obj[CSV_HEADER[index]] = element;
            });
            parsedRows.push(obj);
          }
          setRowIndex(index);
        });
        // localStorage.setItem('recatData', JSON.stringify(parsedRows));
        // console.log("ParsedRows Before:", parsedRows);
        const promises = []
        // console.log("Fetching Status begin");
        let updateCount = 0;
        parsedRows.forEach(row => {
          if(row.status === 'accepted') {
            promises.push(getRecatRequestStatus(row.request_id));
          }
        })
        const results = processPromisesBatch(promises, 10, (response) => {
          response.then((value) => {
            const new_status = value.data.status.indexOf("error") >= 0 ? value.status : value.data.urlrequests[0].status;
            const updated_time = value.data.urlrequests[0].updated_at;
            const index = parsedRows.findIndex(row => row.request_id == value.data.urlrequests[0].id);
            if (parsedRows[index]['status'] != new_status) {
              // console.log("IsChanged:", parsedRows[index]['status'] != new_status);
              updateCount++;
            }
            parsedRows[index]['status'] = new_status;
            parsedRows[index]['last_updated'] = updated_time ?? 0;
            parsedRows[index]['updated_category_id'] = value.data.urlrequests[0].updated_category_id ?? 0;
          });
          return response;
        }).then(results => {
            // console.log("Parsed Rows after update:", parsedRows);
            setRecatRequestsData(parsedRows);
            setSpinner(false);
            if(updateCount > 0) {
              // console.log("Upload Data initiated");
              uploadData(parsedRows);
            }

        })
        .catch(err => {
          setRecatRequestsData(parsedRows);
          setSpinner(false);
        })
      })
    })
      .catch((error) => {
        setSpinner(false);
        //message.error(error);
        setRecatRequestsData([]);
        console.log("Error in reading S3 File", error);
      })
  };

  const deleteFile = async () => {
    const params = { // GetObjectRequest
      Bucket: AWSConfig.BUCKET, // required
      Key: localStorage.getItem('CognitoIdentityID') + "/url-recat-req.csv", // required
    }
    // const command = new ListObjectsCommand({ Bucket: "urlrecategorization" });
    const command = new DeleteObjectCommand(params);
    return s3client.send(command).then((response) => {
      return Promise.resolve(response.DeleteMarker);
    })
    .catch(err => {
      debugger;
      return Promise.resolve(false);
    });
      
  };
  const getExistingCategory = (url) => {
    if (url !== "") {
      setCurrentCategory({ ...currentCategory, loading: true });
      getUrlCategory(url).then(response => {
        setCurrentCategory({ ...currentCategory, loading: false, category_name: categoriesIndex[response.data.cat[0]].category_name, category_id: categoriesIndex[response.data.cat[0]].category_id });
        console.log(currentCategory);
        form.setFieldValue('CurrentCat', categoriesIndex[response.data.cat[0]].category_name);
      })
        .catch(err => {
          setCurrentCategory({ ...currentCategory, loading: false });
          console.log("Err: ", err);
        })
    }
  }
  const onClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setIsFormError(false);
    setSpinner(false);
  };
  const fetchRequestStatus = (evt, row, index) => {
    console.log(requestStatusLoading);
    setRequestStatusLoading({ ...requestStatusLoading, ...{ [index]: true } });
    const arr = [...recatRequestsData];
    setRecatRequestsData(arr);
    setTimeout(() => {
      getRecatRequestStatus(row.request_id).then(response => {
        console.log(response);
        if (response.status == 200) {
          const new_status = response.data.status.indexOf("error") >= 0 ? response.status : response.data.urlrequests[0].status;
          const updated_time = response.data.urlrequests[0].updated_at;
          const data = recatRequestsData;
          data[index]['status'] = new_status;
          data[index]['last_updated'] = updated_time ?? 0;
          data[index]['updated_category_id'] = response.data.urlrequests[0].updated_category_id ?? 0;
          setRequestStatusLoading({ ...requestStatusLoading, ...{ [index]: false } });
          setRecatRequestsData(data);
          uploadData(data);
        }
        else {
          message.error("Error while fetching the status");
        }
      })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
        });
    }, 3000)

  };
  const onChange = (value: string) => {
    console.log(`selected ${categoriesIndex[value].category_name}`);
    setNewCategory({ ...newCategory, category_id: categoriesIndex[value].category_id, category_name: categoriesIndex[value].category_name });
    if (categoriesIndex[value].category_name !== currentCategory.category_name) {
      setIsFormError(false);
    }
    else if (categoriesIndex[value].category_name === currentCategory.category_name) {
      setIsFormError(true);
    }
  };
  const createNewRequest = () => {
    form.resetFields();
    setCurrentCategory({ ...currentCategory, category_id: 0, category_name: '', loading: false });
    setResultStatus({ ...resultStatus, success: false, error: false });
  }
  const retryNewRequest = () => {
    setResultStatus({ ...resultStatus, success: false, error: false });
  }
  useEffect(() => {
    setSpinner(true);
    setCatSpinner(true);
    getCategoriesList().then(response => {
      const categories = {};
      response.data.categories.forEach(item => {
        categories[item.category_id] = item;
      })
      setCategoriesList(response.data.categories);
      setCategoriesIndex(categories);
      setCatSpinner(false);
      // if (localStorage.getItem('recatData')) {
      //   setRecatRequestsData(JSON.parse(localStorage.getItem('recatData')));
      //   setSpinner(false);
      //   return;
      // }
      // else {
      getIdentityId().then(identityId => {
        getUserInformation();
        readFile();
      });
      // }
    });
  }, []);
  const columns: ColumnsType<rowDataType> = [
/*     {
      title: 'ID',
      dataIndex: 'request_id',
      key: 'request_id',
      width: "5%"
    }, */
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      ellipsis: { showTitle: true },
      width: "20%"
    },
    {
      title: 'Current Category',
      dataIndex: 'existing_category_id',
      key: 'existing_category_id',
      render: (cellValue, rowObject) => {
        return categoriesIndex[cellValue]?.category_name || '-';
      },
      width: "18%"
    },
    {
      title: 'Requested Category',
      dataIndex: 'request_category_id',
      key: 'request_category_id',
      render: (cellValue, rowObject) => {
        return categoriesIndex[cellValue]?.category_name || '-';
      },
      width: "18%"
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (cellValue, rowObject, index) => {
        return <>
          <>{requestStatusLoading[index] ? <div className="wobbling-3"></div> : ''}</>
          {!requestStatusLoading[index] && <span>
            {
              cellValue === 'accepted' ? (
                <><ClockCircleOutlined style={{ color: "#00B96F" }} /> <span>In Progress.</span> <span className="reloadIcon">
                  <ReloadOutlined style={{ color: '#08c', fontSize: '18px' }}
                    onClick={(evt) => { fetchRequestStatus(evt, rowObject, index) }} />
                </span></>
              ) : (
                cellValue === 'updated' ? (
                  <><CheckCircleFilled style={{ color: "#00B96F" }} /> <span>Updated</span></>
                ) : (
                  cellValue === 'rejected' ? (
                    <><CloseCircleFilled style={{ color: "#E02020" }} /> <span>Rejected</span></>
                  ) : (
                    <><QuestionCircleOutlined style={{ color: "#E02020" }} /> <span>Rejected</span></>
                  )
                )
              )
            }
          </span>}



          {/* <Button type="link" onClick={} size="sm"></Button>  */}
        </>

      },
      width: "12%"
    },
    {
      title: 'Updated Category',
      dataIndex: 'updated_category_id',
      key: 'updated_category_id',
      render: (cellValue, rowObject) => {
        return categoriesIndex[cellValue]?.category_name || <text className="text-center">-</text>;
      },
      width: "18%"
    },
    {
      title: 'Updated Time',
      dataIndex: 'last_updated',
      key: 'last_updated',
      ellipsis: { showTitle: true },
      render: (cellValue, rowObject, index) => {
        const dt = moment(cellValue);
        return <>
          {dt.isValid() && cellValue !=0 ? moment.utc(cellValue).local().format('MMM DD, YYYY HH:mm A') : <text className="text-center">-</text>}
        </>
      },
      width: "14%"
    },
    {
      title: 'Requested Time',
      dataIndex: 'created_at',
      key: 'created_at',
      ellipsis: { showTitle: true },
      render: (cellValue, rowObject, index) => {
        const dt = moment(cellValue);
        return <>
          {dt.isValid() && cellValue !=0 ? moment.utc(cellValue).local().format('MMM DD, YYYY HH:mm A') : '-'}
        </>
      },
      width: "14%"
    },
    /*     {
          title: 'Request Updated Time',
          dataIndex: 'last_updated',
          key: 'last_updated',
          ellipsis: { showTitle: true },
          width: "15%"
        }, */
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      ellipsis: false,
      render: (cellValue, rowObject, index) => {
        return <>
        <Tooltip placement="leftTop" title={cellValue}>
        <text className="description-txt">{cellValue}</text>
        </Tooltip>
         
        </>
      },
      width: "10%"
    },
  ];
  const isValidUrl = (string) => {
    var expression =
      /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
    var regex = new RegExp(expression);
    if (string.match(regex)) {
      return true;
    } else {
      return false;
    }
  }
  return (  
    <>
      <div className="wrapper pageWrapper">
        <div className="form-container">
          {currentCategory.loading && <div className="cat-loader">
            {/* <div className='loader'>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--text'></div>
            </div> */}
            <Spin className="cat-loader-spinner" size="default" />

          </div>}
          {reqSpinner && <>
            <div className="cat-loader">
              {/* <div className='loader'>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--text'></div>
            </div> */}
              <Spin className="cat-loader-spinner" size="large" />
            </div>
          </>}
          <div className="pageHeader">
            <div className="form-title"> <h2>Request URL Recategorization </h2> <span><span>*</span>Mandatory fields</span></div>
          </div>
          <div className="recatRequestForm mb-5">
            {(resultStatus.success || resultStatus.error) && <Result
              status={resultStatus.success ? "success" : "error"}
              title={resultStatus.success ? "Successfully Submitted request" : "Failed to submit request"}
              subTitle={resultStatus.message}
              extra={resultStatus.success ? [
                <Button type="primary" key="console" size="large" onClick={createNewRequest}>
                  Create New Request
                </Button>
              ] : [
                <Button type="primary" key="console" size="large" onClick={retryNewRequest}>
                  Retry
                </Button>
              ]}
            />}
            {!resultStatus.success && !resultStatus.error && <Row>
              <Col xs={{ span: 20 }} lg={{ span: 10 }}>
                <Form
                  form={form}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 14 }}
                  layout="horizontal"
                  labelAlign="left"
                  colon={false}
                  onFinish={handleSave}
                // style={{ maxWidth: 600 }}
                // size="small"
                >
                  <Form.Item
                    name="url"
                    label="URL"
                    hasFeedback
                    colon={false}
                    validateTrigger="onChange"
                    rules={
                      [
                        { required: true, message: '*URL is required' },
                        {
                          type: 'url', message: 'Must be a valid URL', validator: async (rule, value) => {
                            if (isValidUrl(value)) {
                              return Promise.resolve();
                            }
                            else {
                              return Promise.reject(new Error('Enter a valid URL'));;
                            }
                          }
                        }
                      ]
                    }
                  >
                    <Input placeholder="Enter URL" onBlur={e => getExistingCategory(e.target.value)} />
                  </Form.Item>
                  <Form.Item
                    name="CurrentCat"
                    label="Current Category"
                    initialValue={currentCategory.category_name}
                  >
                    <span>{currentCategory.category_name}</span>
                    {/* <Input placeholder="Current Category" disabled value={currentCategory.category_name} /> */}
                  </Form.Item>
                  <Form.Item name="request_category_id" validateTrigger="onChange" label="Suggested Category" rules={[{ required: true, message: 'Category is required' }]}>
                    <Select showSearch placeholder="Select Category" onChange={onChange} loading={catSpinner} options={categoriesList.map(cat => {
                      return { "value": cat['category_id'], "label": cat['category_name'] }
                    }).sort((a: any, b: any) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1)}
                      filterOption={filterOption}>
                    </Select>
                  </Form.Item>
                  <Form.Item name="description" label="Description" rules={[{ message: 'Description is required' }]}>
                    <TextArea rows={4} placeholder="Describe the reason for requesting Re-Categorization..." />
                  </Form.Item>

                  <Form.Item label=" ">
                    <Button type="primary" htmlType="submit" size="large" block className="custom-btn">
                      Submit Request
                    </Button>
                  </Form.Item>
                  {isFormError && <Alert
                    className="form-alert"
                    message={<><b>Validation Error: </b><span>Selected Category cannot be same as current category</span></>}
                    type="error"
                    closable
                    onClose={onClose}
                  />}
                </Form>
              </Col>
            </Row>}

          </div>
        </div>
        <div className="list-container">
        {spinner && <>
            <div className="cat-loader">
              {/* <div className='loader'>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--dot'></div>
              <div className='loader--text'></div>
            </div> */}
              <Spin className="cat-loader-spinner" size="large" />
            </div>
          </>}
          <div className="pageHeader">
            <div> <h2>URL Recategorization Requests ({recatRequestsData.length})</h2> 
            <InfoCircleFilled style={{ color: '#3596CB' }} /> <span style={{color: '#999999'}}>URL recategorization is only applicable to Juniper NextGen URL categories</span>
            </div>
          </div>
          <div className="recatRequests">
            <Table size="middle" rowKey={"request_id"} dataSource={[...recatRequestsData]} columns={columns} scroll={{ y: 190 }} />
          </div>
        </div>
      </div>
    </>


  );
};

export default Home;
